// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__ZgXK9","opacity-transition":"error_opacity-transition__hADHm"};